export default __webpack_public_path__ + "static/promontory-50f946923b574fe80d9a188825f6da53.jpg";